module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy-button"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('PolicyReveal', {
    attrs: {
      "policyProp": _vm.item
    }
  }), _c('ActionButton', {
    attrs: {
      "action": _vm.remove
    }
  }, [_vm._v("Delete")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27d00843!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/PolicyButtons.vue
// module id = 2352
// module chunks = 1